import React from 'react';
import { Card, Row, Col} from 'react-bootstrap';
import { FaMapMarkerAlt, FaRegCircle } from 'react-icons/fa';
import '../../../assets/css/Drivers/RideDetailCard/RideDetailCard.css';

const RideDetailCard = ({ 
  customerName = "Jonathan Higgins",
  customerRating = "4.8 (127)",
  customerAvatar = null,
  date = "Date",
  time = "15 Feb 25,05:18 AM",
  pickupLocation = "17, Yonge St, Toronto, Canada",
  dropLocation = "20, Yonge St, Toronto, Canada",
  rideFare = "Rs4",
  accessFee = "Rs44",
  charges = "$1",
  totalBill = "$49",
  paymentId = "4011",
  paymentType = "Cash",
  paymentStatus = "Paid"
}) => {
  return (
    <div className="ride-detail-card">
      {/* Header with Customer Info */}
      <Card className="ride-detail-card__header">
        <Card.Body className="p-3">
          <div className="ride-detail-card__customer-info">
            <div className="ride-detail-card__avatar">
              {customerAvatar ? (
                <img src={customerAvatar} alt={customerName} />
              ) : (
                <span>{customerName.charAt(0)}</span>
              )}
            </div>
            <div className="ride-detail-card__customer-details">
              <h6 className="ride-detail-card__customer-name">{customerName}</h6>
              <p className="ride-detail-card__customer-rating">⭐ {customerRating}</p>
            </div>
          </div>

          {/* Date and Time */}
          <Row className="mt-3">
            <Col xs={6}>
              <p className="ride-detail-card__label">{date}</p>
            </Col>
            <Col xs={6} className="text-end">
              <p className="ride-detail-card__value">{time}</p>
            </Col>
          </Row>

          {/* Pickup and Drop Locations */}
          <div className="ride-detail-card__locations">
            <div className="ride-detail-card__location-item">
              <FaRegCircle className="ride-detail-card__location-icon pickup" />
              <p className="ride-detail-card__location-text">{pickupLocation}</p>
            </div>
            <div className="ride-detail-card__location-item">
              <FaMapMarkerAlt className="ride-detail-card__location-icon drop" />
              <p className="ride-detail-card__location-text">{dropLocation}</p>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Bill Details */}
      <Card className="ride-detail-card__bill mt-3">
        <Card.Body className="p-3">
          <h6 className="ride-detail-card__section-title">Bill Details</h6>
          
          <div className="ride-detail-card__bill-row">
            <span className="ride-detail-card__bill-label">Ride Fare</span>
            <span className="ride-detail-card__bill-value">{rideFare}</span>
          </div>
          <div className="ride-detail-card__bill-row">
            <span className="ride-detail-card__bill-label">Total Access Fee</span>
            <span className="ride-detail-card__bill-value">{accessFee}</span>
          </div>
          <div className="ride-detail-card__bill-row">
            <span className="ride-detail-card__bill-label">Charges Savings</span>
            <span className="ride-detail-card__bill-value charges">{charges}</span>
          </div>
          
          <hr className="ride-detail-card__divider" />
          
          <div className="ride-detail-card__bill-row total">
            <span className="ride-detail-card__bill-label">Total Bill</span>
            <span className="ride-detail-card__bill-value">{totalBill}</span>
          </div>
        </Card.Body>
      </Card>

      {/* Payment Method */}
      <Card className="ride-detail-card__payment mt-3">
        <Card.Body className="p-3">
          <h6 className="ride-detail-card__section-title">Payment Method</h6>
          
          <div className="ride-detail-card__payment-row">
            <span className="ride-detail-card__payment-label">Payment ID</span>
            <span className="ride-detail-card__payment-value">{paymentId}</span>
          </div>
          <div className="ride-detail-card__payment-row">
            <span className="ride-detail-card__payment-label">Payment Type</span>
            <span className="ride-detail-card__payment-value">{paymentType}</span>
          </div>
          <div className="ride-detail-card__payment-row">
            <span className="ride-detail-card__payment-label">Status</span>
            <span className="ride-detail-card__payment-value status">{paymentStatus}</span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default RideDetailCard;